import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteMaintenancePlan } from "../../services/maintenance-plan";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function MaintenancePlanDelete() {
  const navigate = useNavigate();
  const { get: getLocale } = useLocale();
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Maintenance plan ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/maintenance/plan");
  };

  return (
    <Confirm
      header={getLocale("maintenance.confirmDeletePlan")}
      loading={loading}
      onClose={closeModal}
      onConfirm={() => {
        void (async () => {
          setLoading(true);
          try {
            await deleteMaintenancePlan(id);
            await queryClient.invalidateQueries({
              queryKey: ["maintenancePlans"],
            });
          } finally {
            setLoading(false);
            closeModal();
          }
        })();
      }}
    />
  );
}
